import { useInfiniteQuery } from '@tanstack/react-query';
import { fetchFakultas } from '../api/get-fakultas';
import { columnsFakultas } from './columns-fakultas';
import { DataTable } from '@/components/ui/data-table';
import React from 'react';

export function FakultasTable() {
  const { 
    data, 
    isLoading, 
    isError, 
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage
  } = useInfiniteQuery({
    queryKey: ['master-fakultas'],
    queryFn: ({ pageParam }) => fetchFakultas({ pageParam }),
    initialPageParam: 1,
    getNextPageParam: (lastPage, allPages) => {
      if (lastPage.is_next) {
        return allPages.length + 1;
      }
      return undefined;
    },
  });

  const fakultasData = React.useMemo(() => {
    const rawData = data?.pages.flatMap((page) => page.datas) || [];
    const uniqueParams = new Map();
    rawData.forEach((item) => {
      uniqueParams.set(item.master_fakultas_id, item);
    });
    return Array.from(uniqueParams.values());
  }, [data]);

  if (isLoading) {
    return <div className="p-6">Loading data fakultas...</div>;
  }

  if (isError) {
    return <div className="p-6 text-red-500">Error: {(error as Error).message}</div>;
  }

  return (
    <DataTable 
      columns={columnsFakultas} 
      data={fakultasData}
      onReachBottom={() => fetchNextPage()}
      isFetchingNextPage={isFetchingNextPage}
      hasNextPage={hasNextPage}
    />
  );
}
